export const translations = {
  fr: {
    nav: {
      maison: "La Maison",
      manifeste: "Manifeste",
      residents: "Artistes & Scientifiques",
      bureau: "Le Bureau",
      evenements: "Millenium 2027",
      boutique: "Boutique",
      journal: "Journal",
      galerie: "Galerie",
      contact: "Contact",
      open_menu: "Ouvrir le menu",
      close_menu: "Fermer le menu",
      theme_to_light: "Passer en mode Parchemin",
      theme_to_dark: "Passer en mode Nuit",
    },
    hero: {
      kicker: "Prieuré Saint-Léonard de Vains · Baie du Mont-Saint-Michel",
      overture: "Maison Guillaume le Conquérant pour l'Art et la Science",
      words: ["Chercher", "Créer", "Transmettre"],
      sub: "Dans la baie du Mont-Saint-Michel, le Prieuré Saint-Léonard réunit artistes et scientifiques autour de neuf arts — la cuisine, les parfums, les étoffes, la musique, le cinéma, le théâtre, la sculpture, la peinture et l'écriture. Une maison opérée par VIVA ARTIST, où le profane rejoint le sacré.",
      cta_primary: "Découvrir la Maison",
      cta_secondary: "Rencontrer les membres",
      scroll: "Descendre",
      inauguration: "Inauguration de la Maison · 1er novembre 2026",
      countdown: { days: "Jours", hours: "Heures", minutes: "Minutes", seconds: "Secondes" },
    },
    marquee: [
      "Maison pour l'Art et la Science",
      "Chercher · Créer · Transmettre",
      "Les Neuf Arts",
      "Opérée par VIVA ARTIST",
      "Baie du Mont-Saint-Michel",
    ],
    manifesto: {
      kicker: "Le Manifeste",
      title: "Trois gestes, une seule âme",
      chapters: [
        {
          num: "01",
          title: "Chercher",
          text: "Sous la lumière changeante de la baie, la Maison accueille celles et ceux qui interrogent le monde : astronautes, climatologues, physiciens, penseurs. Entre grèves et ciels, le Prieuré devient un observatoire où la science dialogue avec le silence.",
        },
        {
          num: "02",
          title: "Créer",
          text: "Neuf arts vivent sous le toit du Prieuré : la cuisine, les parfums, les étoffes, la musique, le cinéma, le théâtre, la sculpture, la peinture et l'écriture. VIVA ARTIST y produit des œuvres qui sculptent la lumière et le souffle — du chant sacré réinventé aux étoffes teintes à la garance.",
        },
        {
          num: "03",
          title: "Transmettre",
          text: "Masterclasses, rencontres publiques, éditions et fêtes populaires : la Maison partage ce qu'elle cherche et ce qu'elle crée. Vers le Millenium 2027, elle fait de la transmission une fête — libération, lumière, unité.",
        },
      ],
    },
    lieu: {
      kicker: "Le Lieu",
      title: "Le Prieuré & la Baie",
      text: "Face au Mont-Saint-Michel, le Prieuré Saint-Léonard de Vains veille sur la baie depuis près de mille ans. Ses pierres, sa chapelle et ses grèves offrent aux artistes et aux scientifiques un horizon unique — celui où le profane rejoint le sacré.",
      address: "Abbaye Saint-Léonard · Le Bourg, 50300 Vains · Manche",
      captions: [
        "La baie du Mont-Saint-Michel et l'abbaye",
        "La baie en fleurs au pied du Prieuré",
        "Visite guidée de l'abbaye",
        "La grève au fil de la marée",
      ],
    },
    people: {
      kicker: "Les Membres",
      title: "Artistes & Scientifiques",
      sub: "Sculpteurs, peintres, photographes, musiciens et chefs, mais aussi astronautes, scientifiques et penseurs — réunis par VIVA ARTIST autour de la Maison pour l'Art et la Science.",
      filters: { all: "Tous", artistes: "Artistes", musiciens: "Musiciens", scientifiques: "Scientifiques" },
      view: "Voir la fiche",
      close: "Fermer",
      visit: "Site officiel",
      video: "Regarder",
      loading: "Chargement des fiches…",
    },
    bureau: {
      kicker: "La Gouvernance",
      title: "Le Bureau de VIVA ARTIST",
      sub: "La Maison pour l'Art et la Science est opérée par VIVA ARTIST, le label tous médias du Prieuré. Son bureau porte la vision du lieu et accompagne chaque résidence, chaque création, chaque transmission.",
    },
    gallery: {
      kicker: "En Images",
      title: "La Baie & le Prieuré",
      close: "Fermer",
    },
    audio: {
      title: "Vivaldi — Le Printemps",
      artist: "Violon · John Harrison",
      play: "Écouter l'ambiance du Prieuré",
      pause: "Couper la musique",
    },
    contact: {
      kicker: "Écrivez-nous",
      title: "Un projet, une résidence, une visite ?",
      sub: "La Maison accueille les créateurs et les chercheurs dont le travail relie le profane au sacré. Un geste suffit pour nous écrire.",
      name: "Nom",
      email: "Courriel",
      subject: "Objet",
      subjects: ["Visite du Prieuré", "Résidence artistique", "Résidence scientifique", "Presse & partenariats", "Autre demande"],
      message: "Message",
      send: "Envoyer",
      sending: "Envoi…",
      success: "Votre message a bien été envoyé. Merci !",
      error: "Une erreur est survenue. Réessayez.",
      find_us: "Nous trouver",
      itinerary: "Itinéraire",
    },
    events: {
      kicker: "Millenium · MMXXVII",
      title: "Fêtes populaires de saint Léonard",
      sub: "Cinq jours de Libération, Lumière et Unité — du 1er au 6 juillet 2027, entre la chapelle, les jardins et les grèves de la baie.",
      book: "Réserver",
      places: "places",
      remaining: "places restantes",
      full: "Complet",
      booking_full: "Cet événement est complet.",
      booking_intro: "Réservez vos places directement auprès de la Maison — nous vous confirmerons par courriel.",
      booking_name: "Nom",
      booking_email: "Courriel",
      booking_seats: "Nombre de places",
      booking_message: "Message (facultatif)",
      booking_send: "Confirmer la réservation",
      booking_sending: "Envoi…",
      booking_success: "Votre réservation a bien été enregistrée. À bientôt au Prieuré !",
      booking_error: "Une erreur est survenue. Réessayez.",
      booking_close: "Fermer",
    },
    boutique: {
      kicker: "Acquérir",
      title: "La Boutique des Œuvres",
      sub: "Des œuvres uniques produites par le label VIVA ARTIST. Chaque acquisition prolonge mille ans d'histoire.",
      all: "Tout",
      enquire: "Acquérir",
      view_work: "Voir l'œuvre",
      back_to_shop: "Retour à la boutique",
      not_found: "Œuvre introuvable.",
      on_request: "Sur demande",
      enquiry_prefix: "Bonjour, je souhaite acquérir l'œuvre « ",
      enquiry_suffix: " ». Merci de bien vouloir me recontacter.",
      categories: {
        peinture: "Peinture",
        etoffe: "Étoffe",
        parfum: "Parfum",
        cinema: "Cinéma",
        ecriture: "Écriture",
        sculpture: "Sculpture",
        photographie: "Photographie",
        theatre: "Théâtre",
        cuisine: "Cuisine",
      },
    },
    presence: {
      kicker: "L'Œuvre du Millenium",
      title: "L'Histoire de PRÉSENCE",
      intro: "Une œuvre monumentale sculptée par Auriane de Potesta pour le Mont-Saint-Michel. Trois figures — la Libération, la Lumière et l'Unité — nées de la terre de la baie, promises au bronze et à l'éternité.",
      stages: [
        {
          num: "I",
          place: "Prieuré Saint-Léonard · Vains",
          title: "L'Argile",
          text: "Dans l'atelier de pierre du Prieuré, Auriane de Potesta fait jaillir de la terre trois figures enlacées : la Libération, la Lumière et l'Unité.",
        },
        {
          num: "II",
          place: "Fonderie BMN ARTE · Vérone",
          title: "Le Bronze",
          text: "La fonte à la cire perdue donne à l'argile son éternité : la fonderie d'art BMN ARTE, à Vérone, coule l'œuvre dans le bronze.",
        },
        {
          num: "III",
          place: "Vatican · Rome",
          title: "La Bénédiction",
          text: "Avant son départ pour la Normandie, l'œuvre est bénie par le pape Léon XIV à Rome.",
        },
        {
          num: "IV",
          place: "Mont-Saint-Michel · 3 juillet 2027",
          title: "La Destination",
          text: "Lors des Fêtes populaires de saint Léonard, PRÉSENCE monte vers l'Abbatiale, portée par la musique de Renara Akhoundova et le Requiem pour un Conquérant de Gérard Legoupil.",
        },
      ],
      cta_shop: "Découvrir l'œuvre en boutique",
      cta_more: "La fiche complète sur VIVA ARTIST",
    },
    inauguration: {
      kicker: "Save the Date",
      title: "Inauguration de la Maison",
      date: "1er novembre 2026",
      sub: "La Maison pour l'Art et la Science ouvrira officiellement ses portes au Prieuré Saint-Léonard de Vains. Artistes, scientifiques, amis de la Maison — soyez des nôtres.",
      form_title: "Demander une invitation",
      name: "Nom",
      email: "Courriel",
      guests: "Nombre de convives",
      guests_options: ["1 personne", "2 personnes", "3 personnes", "4 personnes", "5 personnes et +"],
      message: "Message (facultatif)",
      send: "Envoyer ma demande",
      sending: "Envoi…",
      success: "Votre demande d'invitation a bien été envoyée. À très vite !",
      error: "Une erreur est survenue. Réessayez.",
    },
    fresque: {
      kicker: "La Fresque en Direct",
      title: "La chapelle se refait une beauté",
      sub: "Semaine après semaine, Maciej Leszczyński fait naître la fresque du chœur. Suivez sa création jusqu'à la bénédiction du 4 juillet 2027.",
      upcoming: "À venir",
      blessing_note: "Messe solennelle de l'Unité · Prieuré Saint-Léonard",
      entries: [
        { date: "Printemps 2026", title: "La chapelle se prépare", text: "Échafaudages, protection de l'autel, relevés des pierres : le chœur devient un atelier.", image: "/images/lieux/interieur-89.webp" },
        { date: "Été 2026", title: "Le tracé s'élève", text: "Au crayon, la figure centrale prend vie sur la paroi du chœur, entre les deux baies romanes.", image: "/images/lieux/interieur-88.webp" },
        { date: "Automne 2026", title: "Les premières couleurs", text: "Les pigments rejoignent la pierre : l'ocre, l'or et le bleu de la baie.", image: "" },
        { date: "Printemps 2027", title: "L'achèvement", text: "Les derniers apports, les dorures, puis le retrait des échafaudages.", image: "" },
        { date: "4 juillet 2027 · 9h30", title: "La bénédiction des fresques", text: "Lors de la messe solennelle de l'Unité, les fresques et l'autel sont bénis — un temps fort du Millenium 2027.", image: "" },
      ],
    },
    journal: {
      kicker: "Le Journal",
      title: "Les nouvelles de la Maison",
      read: "Lire l'article",
    },
    footer: {
      motto: "Chercher, créer, transmettre",
      operated: "Une maison opérée par",
      rights: "Tous droits réservés",
      music_credit: "Musique : Vivaldi, Les Quatre Saisons — Le Printemps, John Harrison (violon), domaine public via Wikimedia Commons.",
    },
  },
  en: {
    nav: {
      maison: "The House",
      manifeste: "Manifesto",
      residents: "Artists & Scientists",
      bureau: "The Board",
      evenements: "Millennium 2027",
      boutique: "Boutique",
      journal: "Journal",
      galerie: "Gallery",
      contact: "Contact",
      open_menu: "Open menu",
      close_menu: "Close menu",
      theme_to_light: "Switch to Parchment mode",
      theme_to_dark: "Switch to Night mode",
    },
    hero: {
      kicker: "Saint-Léonard Priory of Vains · Bay of Mont-Saint-Michel",
      overture: "The House for Art and Science",
      words: ["To Seek", "To Create", "To Transmit"],
      sub: "In the bay of Mont-Saint-Michel, the Saint-Léonard Priory brings artists and scientists together around nine arts — cuisine, perfume, textiles, music, cinema, theatre, sculpture, painting and writing. A house operated by VIVA ARTIST, where the profane meets the sacred.",
      cta_primary: "Discover the House",
      cta_secondary: "Meet the members",
      scroll: "Scroll",
      inauguration: "Inauguration of the House · 1 November 2026",
      countdown: { days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds" },
    },
    marquee: [
      "House for Art and Science",
      "To Seek · To Create · To Transmit",
      "The Nine Arts",
      "Operated by VIVA ARTIST",
      "Bay of Mont-Saint-Michel",
    ],
    manifesto: {
      kicker: "The Manifesto",
      title: "Three gestures, one soul",
      chapters: [
        {
          num: "01",
          title: "To Seek",
          text: "Beneath the ever-changing light of the bay, the House welcomes those who question the world: astronauts, climatologists, physicists, thinkers. Between tidal flats and shifting skies, the Priory becomes an observatory where science converses with silence.",
        },
        {
          num: "02",
          title: "To Create",
          text: "Nine arts live under the Priory's roof: cuisine, perfume, textiles, music, cinema, theatre, sculpture, painting and writing. VIVA ARTIST produces works that sculpt light and breath — from reinvented sacred song to madder-dyed silks.",
        },
        {
          num: "03",
          title: "To Transmit",
          text: "Masterclasses, public talks, publications and popular festivities: the House shares what it seeks and what it creates. Towards Millennium 2027, it turns transmission into a celebration — liberation, light, unity.",
        },
      ],
    },
    lieu: {
      kicker: "The Place",
      title: "The Priory & the Bay",
      text: "Facing Mont-Saint-Michel, the Saint-Léonard Priory of Vains has watched over the bay for nearly a thousand years. Its stones, chapel and tidal flats offer artists and scientists a singular horizon — where the profane meets the sacred.",
      address: "Abbey of Saint-Léonard · Le Bourg, 50300 Vains · Normandy",
      captions: [
        "The bay of Mont-Saint-Michel and the abbey",
        "The bay in bloom at the foot of the Priory",
        "Guided tour of the abbey",
        "The shore as the tide flows",
      ],
    },
    people: {
      kicker: "The Members",
      title: "Artists & Scientists",
      sub: "Sculptors, painters, photographers, musicians and conductors — but also astronauts, scientists and thinkers, gathered by VIVA ARTIST around the House for Art and Science.",
      filters: { all: "All", artistes: "Artists", musiciens: "Musicians", scientifiques: "Scientists" },
      view: "View profile",
      close: "Close",
      visit: "Official website",
      video: "Watch",
      loading: "Loading profiles…",
    },
    bureau: {
      kicker: "Governance",
      title: "The VIVA ARTIST Board",
      sub: "The House for Art and Science is operated by VIVA ARTIST, the all-media label of the Priory. Its board carries the vision of the place and supports every residency, every creation, every transmission.",
    },
    gallery: {
      kicker: "In Pictures",
      title: "The Bay & the Priory",
      close: "Close",
    },
    audio: {
      title: "Vivaldi — Spring",
      artist: "Violin · John Harrison",
      play: "Listen to the Priory atmosphere",
      pause: "Mute the music",
    },
    contact: {
      kicker: "Write to us",
      title: "A project, a residency, a visit?",
      sub: "The House welcomes creators and researchers whose work binds the profane to the sacred. A single gesture is enough to reach us.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      subjects: ["Priory visit", "Artistic residency", "Scientific residency", "Press & partnerships", "Other enquiry"],
      message: "Message",
      send: "Send",
      sending: "Sending…",
      success: "Your message has been sent. Thank you!",
      error: "Something went wrong. Please try again.",
      find_us: "Find us",
      itinerary: "Directions",
    },
    events: {
      kicker: "Millennium · MMXXVII",
      title: "Popular Feasts of Saint Leonard",
      sub: "Five days of Liberation, Light and Unity — 1 to 6 July 2027, between the chapel, the gardens and the tidal flats of the bay.",
      book: "Book now",
      places: "seats",
      remaining: "seats left",
      full: "Fully booked",
      booking_full: "This event is fully booked.",
      booking_intro: "Book your seats directly with the House — we will confirm by email.",
      booking_name: "Name",
      booking_email: "Email",
      booking_seats: "Number of seats",
      booking_message: "Message (optional)",
      booking_send: "Confirm booking",
      booking_sending: "Sending…",
      booking_success: "Your booking has been recorded. See you at the Priory!",
      booking_error: "Something went wrong. Please try again.",
      booking_close: "Close",
    },
    boutique: {
      kicker: "Acquire",
      title: "The Artworks Boutique",
      sub: "Unique works produced by the VIVA ARTIST label. Every acquisition extends a thousand years of history.",
      all: "All",
      enquire: "Acquire",
      view_work: "View artwork",
      back_to_shop: "Back to the boutique",
      not_found: "Artwork not found.",
      on_request: "On request",
      enquiry_prefix: "Hello, I would like to acquire the artwork \"",
      enquiry_suffix: "\". Please get back to me.",
      categories: {
        peinture: "Painting",
        etoffe: "Fabric",
        parfum: "Perfume",
        cinema: "Cinema",
        ecriture: "Writing",
        sculpture: "Sculpture",
        photographie: "Photography",
        theatre: "Theatre",
        cuisine: "Food & Terroir",
      },
    },
    presence: {
      kicker: "The Millennium Artwork",
      title: "The Story of PRÉSENCE",
      intro: "A monumental work sculpted by Auriane de Potesta for Mont-Saint-Michel. Three figures — Liberation, Light and Unity — born from the clay of the bay, promised to bronze and eternity.",
      stages: [
        {
          num: "I",
          place: "Saint-Léonard Priory · Vains",
          title: "The Clay",
          text: "In the stone workshop of the Priory, Auriane de Potesta draws three entwined figures out of the earth: Liberation, Light and Unity.",
        },
        {
          num: "II",
          place: "BMN ARTE Foundry · Verona",
          title: "The Bronze",
          text: "Lost-wax casting grants the clay its eternity: the BMN ARTE art foundry in Verona pours the work into bronze.",
        },
        {
          num: "III",
          place: "Vatican · Rome",
          title: "The Blessing",
          text: "Before leaving for Normandy, the work is blessed by Pope Leo XIV in Rome.",
        },
        {
          num: "IV",
          place: "Mont-Saint-Michel · 3 July 2027",
          title: "The Destination",
          text: "During the popular feasts of Saint Leonard, PRÉSENCE ascends towards the Abbey church, carried by the music of Renara Akhoundova and Gérard Legoupil's Requiem pour un Conquérant.",
        },
      ],
      cta_shop: "Discover the artwork in the boutique",
      cta_more: "Full artwork page on VIVA ARTIST",
    },
    inauguration: {
      kicker: "Save the Date",
      title: "Inauguration of the House",
      date: "1 November 2026",
      sub: "The House for Art and Science will officially open its doors at the Saint-Léonard Priory of Vains. Artists, scientists, friends of the House — join us.",
      form_title: "Request an invitation",
      name: "Name",
      email: "Email",
      guests: "Number of guests",
      guests_options: ["1 guest", "2 guests", "3 guests", "4 guests", "5 guests and more"],
      message: "Message (optional)",
      send: "Send my request",
      sending: "Sending…",
      success: "Your invitation request has been sent. See you very soon!",
      error: "Something went wrong. Please try again.",
    },
    fresque: {
      kicker: "The Fresco, Live",
      title: "The chapel is reborn",
      sub: "Week after week, Maciej Leszczyński brings the choir fresco to life. Follow its creation until the blessing on 4 July 2027.",
      upcoming: "Coming soon",
      blessing_note: "Solemn Mass of Unity · Saint-Léonard Priory",
      entries: [
        { date: "Spring 2026", title: "The chapel prepares", text: "Scaffolding, altar protection, stone surveys: the choir becomes a workshop.", image: "/images/lieux/interieur-89.webp" },
        { date: "Summer 2026", title: "The drawing rises", text: "In pencil, the central figure comes to life on the choir wall, between the two Romanesque bays.", image: "/images/lieux/interieur-88.webp" },
        { date: "Autumn 2026", title: "The first colours", text: "Pigments meet the stone: ochre, gold and the blue of the bay.", image: "" },
        { date: "Spring 2027", title: "The completion", text: "The final touches, the gilding, then the scaffolding comes down.", image: "" },
        { date: "4 July 2027 · 9:30am", title: "The blessing of the frescoes", text: "During the solemn Mass of Unity, the frescoes and the altar are blessed — a highlight of Millennium 2027.", image: "" },
      ],
    },
    journal: {
      kicker: "The Journal",
      title: "News from the House",
      read: "Read the article",
    },
    footer: {
      motto: "To seek, to create, to transmit",
      operated: "A house operated by",
      rights: "All rights reserved",
      music_credit: "Music: Vivaldi, The Four Seasons — Spring, John Harrison (violin), public domain via Wikimedia Commons.",
    },
  },
};
